<script lang="ts">
	import { onMount } from 'svelte';
	import { AuthenticationService } from '../../domain-services/Authentication.service';
	import { isTokenExpired } from '../../_features_/shared/utils';
	interface Props {
		children?: import('svelte').Snippet;
	}

	let { children }: Props = $props();

	const authenticationService = new AuthenticationService();
	let token = $state('');
	let tokenExpired = $state(true);

	onMount(async () => {
		await authenticationService.connectIfNoAccessToken(); // If no authentication cookies we authenticate the user
		token = authenticationService.getAccessToken() ?? '';
		tokenExpired = isTokenExpired(token);
		if (tokenExpired) {
			// If the token is expired, get a new token
			await authenticationService.updateTokens();
		}
	});
</script>

<div>
	{#if !!token && !tokenExpired}
		{@render children?.()}
	{/if}
</div>
